/**
 * Decisão do gate de disponibilidade antes da geração da rota.
 *
 * Regras vinculativas:
 * - Com locais obrigatórios e janela explícita, uma falha TÉCNICA na
 *   verificação de horários BLOQUEIA a geração (nunca continua
 *   automaticamente): o utilizador tem de escolher "Tentar novamente" ou
 *   "Continuar sem confirmar horários".
 * - Sem locais obrigatórios ou sem janela explícita, a verificação nem sequer
 *   corre — a geração segue normalmente.
 */

export type AvailabilityPrecheckOutcome = "proceed" | "block_technical";

export function resolveTechnicalFailureOutcome(opts: {
  requiredPlacesCount: number;
  hasExplicitWindow: boolean;
}): AvailabilityPrecheckOutcome {
  if (opts.requiredPlacesCount > 0 && opts.hasExplicitWindow) {
    return "block_technical";
  }
  return "proceed";
}
